import { Button, Col, Input, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

function ShowParticipant(props) {

    function renderButton() {
        if (props.readonly) {
            return (<></>);
        }
        else {
            return (
                <Popconfirm
                    title={props.lastName + ", " + props.firstName + " wirklich abmelden?"}
                    okText="Abmelden"
                    cancelText="Abbrechen"
                    okButtonProps={{ type: "danger" }}
                    onConfirm={props.onClick}
                >
                    <Button
                        icon={<DeleteOutlined />}
                    >
                        Abmelden
                    </Button>
                </Popconfirm>
            )
        }
    }

    return (
        <>
            <Col span={8} offset={2}>
                <Input bordered={false} value={props.lastName} />
            </Col>
            <Col span={8}>
                <Input bordered={false} value={props.firstName} />
            </Col>
            <Col span={4}>
                {
                    renderButton()
                }
            </Col>
            <Col span={2}>
            </Col>
        </>
    )
};

export default ShowParticipant;